module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12_01-5a12b8f52a20fab30b1030f916dd411d.svg";